import { useState } from "react";

export const useSignInError = () => {
  const [hasError, setHasError] = useState(false);
  const showError = () => setHasError(true);
  const clearError = () => setHasError(false);
  return { hasError, showError, clearError };
};
